import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { m as merge } from '../../unsorted/index.js';
import { useFetchLogoContent } from '../../hooks/useFetchLogoContent.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { S as SvgIcon } from '../SvgIcon/SvgIcon.js';

var _excluded = ["sx", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function RollupX(_ref) {
  var _svgContent$join;
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded);
  var svgContent = useFetchLogoContent("RollupX");
  return jsx(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 33 32",
    testId: testId,
    sx: merge({
      w: "200px"
    }, sx),
    children: svgContent && jsx("g", {
      "data-testid": "".concat(testId, "__g"),
      dangerouslySetInnerHTML: {
        __html: svgContent === null || svgContent === void 0 || (_svgContent$join = svgContent.join) === null || _svgContent$join === void 0 ? void 0 : _svgContent$join.call(svgContent, "")
      }
    })
  }));
}
RollupX.displayName = "RollupX";

export { RollupX };
//# sourceMappingURL=RollupX.js.map
